import React from 'react'; // eslint-disable-line no-unused-vars
import { countryString } from '../../validators/location';

export const AddressSummary = (props, unknown = '') => {
  if (!props) {
    return unknown;
  }

  const {
    street = '', street2 = '', city = '', state = '', zipcode = ''
  } = props;
  const address1 = `${street} ${street2}`.trim();
  const country = countryString(props.country);
  let address2 = '';

  if (['United States', 'POSTOFFICE'].includes(country)) {
    address2 = `${city}, ${state} ${zipcode}`.trim();
  } else if (country !== '') {
    address2 = `${city}, ${country}`.trim();
  }

  if (address1.length === 0 || address2.length === 1) {
    return unknown;
  }

  return <span>{`${address1}, ${address2}`.trim()}</span>;
};
